<template>
  <div class="d-flex flex-column align-center justify-center w-100 fill-height">
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-circular>
    <div class="container global-tradingview trading-view">
      <div id="tradingview_wrapper" class="tradingview-widget-container d-none">
        <div id="tradingview_54dbc" class="trading-view-in"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "globalTradingView",
  props: {
    currentCoin: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      option: {
        autosize: true,
        symbol: "BINANCE:BTCUSDT",
        interval: "1",
        timezone: "Asia/Tehran",
        theme: this.$vuetify.theme.dark ? "dark" : "light",
        style: "1",
        locale: "en",
        toolbar_bg: "#f1f3f6",
        enabled_features: [
          "header_fullscreen_button",
          "side_toolbar_in_fullscreen_mode",
          "header_in_fullscreen_mode"
        ],
        disabled_features: [
          "use_localstorage_for_settings",
          "volume_force_overlay"
        ],
        enable_publishing: false,
        withdateranges: true,
        range: "YTD",
        hide_side_toolbar: false,
        allow_symbol_change: true,
        calendar: true,
        container_id: "tradingview_54dbc"
      }
    };
  },
  mounted() {
    this.createChart();
  },

  watch: {
    "$vuetify.theme.dark": {
      handler() {
        this.option.theme = this.$vuetify.theme.dark ? "dark" : "light";
        this.createChart();
      },
      immediate: true // Triggers on component creation
    }
  },
  methods: {
    createChart() {
      // console.log(this.currentCoin);
      this.option.symbol = this.currentCoin.symbol
        .replace("BTCB", "BTC")
        .replace("/", "");
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://s3.tradingview.com/tv.js";
      script.id = "tradingViewID";
      document.head.appendChild(script);
      setTimeout(() => {
        new window.TradingView.widget(this.option);
        setTimeout(() => {
          document
            .getElementById("tradingview_wrapper")
            .classList.add("d-block");
          this.loading = false;
        }, 2000);
      }, 2000);
    }
  }
};
</script>
<style scoped lang="scss"></style>
